import { CompletedRow } from './CompletedRow'
import { CurrentRow } from './CurrentRow'
import { EmptyRow } from './EmptyRow'

type Props = {
  guesses: string[]
  currentGuess: string
  cursorPosition: number
  onCellClick: (position: number) => void
}

export const Grid = ({ guesses, currentGuess, cursorPosition, onCellClick }: Props) => {
  const empties =
    guesses.length < 5 ? Array.from(Array(5 - guesses.length)) : []

  return (
    <div className="pb-6 max-[375px]:pb-3 max-[350px]:pb-3 max-[320px]:pb-4">
      {guesses.map((guess, i) => (
        <CompletedRow key={i} guess={guess} />
      ))}
      {guesses.length < 6 && (
        <CurrentRow 
          guess={currentGuess} 
          cursorPosition={cursorPosition}
          onCellClick={onCellClick}
        />
      )}
      {empties.map((_, i) => (
        <EmptyRow key={i} />
      ))}
    </div>
  )
}
